import { render } from "./SmartCloud.vue?vue&type=template&id=246ba2a6&scoped=true"
const script = {}

import "./SmartCloud.vue?vue&type=style&index=0&id=246ba2a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246ba2a6"]])

export default __exports__